import React from 'react';

import { useSettingsContext } from 'lib/contexts/settings';
import { Switch } from 'toolkit/chakra/switch';

const SettingsDateTimeFormat = () => {
  const settingsContext = useSettingsContext();

  if (!settingsContext) {
    return null;
  }

  const { timeFormat, toggleTimeFormat } = settingsContext;

  return (
    <Switch
      id="time-format"
      checked={ timeFormat === 'absolute' }
      onChange={ toggleTimeFormat }
      mt={ 4 }
      direction="rtl"
      justifyContent="space-between"
      w="100%"
    >
      Show absolute date & time
    </Switch>
  );
};

export default React.memo(SettingsDateTimeFormat);
